import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../api";

export default function EmployeePay() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/loads/${id}/employee-pay`).then(r => setData(r.data));
  }, [id]);

  if (!data) return null;

  return (
    <div className="container">
      <h3>Total Truck Pay: ${data.load_total}</h3>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Employee</th>
            <th>Minutes</th>
            <th>Payout</th>
          </tr>
        </thead>
        <tbody>
          {data.employees.map((e, i) => (
            <tr key={i}>
              <td>{e.employee}</td>
              <td>{e.minutes}</td>
              <td>${e.pay}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
